var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivated({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27.5,
    r: 27,
    fill: "url(#paint0_linear_264_21201)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9997 38.6667C33.4163 38.6667 38.6663 33.4167 38.6663 27C38.6663 20.5834 33.4163 15.3334 26.9997 15.3334C20.583 15.3334 15.333 20.5834 15.333 27C15.333 33.4167 20.583 38.6667 26.9997 38.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.042 27L25.3437 30.3017L31.9587 23.6984",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_21201",
    x1: 0,
    y1: 0.5,
    x2: 54,
    y2: 54.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.311654,
    stopColor: "#44BE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75983,
    stopColor: "#27AE60"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivated);
export default __webpack_public_path__ + "static/media/Activated.8bbfb92d4a3f3a90d5f409649e5b2b54.svg";
export { ForwardRef as ReactComponent };